import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLatestMessage } from 'redux-flash';
import { Modal } from 'components/shared';
import { IconCheck, IconTime } from 'icons';

const propTypes = {
  flash: PropTypes.shape({
    message: PropTypes.string.isRequired,
  }),
};

const defaultProps = {
  flash: null,
};

class FlashMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { flash: props.flash, isOpen: !!props.flash };
  }

  componentWillReceiveProps({ flash }) {
    if (flash) {
      this.setState({ flash, isOpen: true });
    } else {
      this.setState({ isOpen: false });
      setTimeout(() => this.setState({ flash: undefined }), 1000);
    }
  }

  render() {
    const { flash, isOpen } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        contentLabel="Flash Message"
        onRequestClose={() => this.setState({ isOpen: false })}
      >
        <div className="Modal__Content">
          <div className="Modal__FlashIcon">
            {flash && flash.isError ? <IconTime /> : <IconCheck />}
          </div>

          {flash && flash.message}
        </div>
      </Modal>
    );
  }
}

FlashMessage.propTypes = propTypes;
FlashMessage.defaultProps = defaultProps;

const mapStateToProps = state => ({
  flash: getLatestMessage(state),
});

export default connect(mapStateToProps)(FlashMessage);



// WEBPACK FOOTER //
// ./src/components/shared/FlashMessage/FlashMessage.jsx